import { useEffect, useState } from "react";
import { RadioInput, TextInput, DateInput, NewSelectInput } from "../ui/Input";
import { fetchArticleByIssue } from "../../services/apiService/articleApi";
import { CustomTable } from "../Table";
import { filteredArticleHeaders } from "../../lib/utils";
import * as XLSX from "xlsx";
import { useRef } from "react";
import Book from "../../assets/article_shortcut.png";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Spinner } from "../ui/Skeleton";
import bookPng from "../../assets/article.png";



let IssueDetails = ({
  formdata,
  onSave,
  Onclose,
  fieldConfig,
  userOption,
  text,
  optionsMap,
}) => {
  const [formData, setFormData] = useState({});
  const [initialFormData, setInitialFormData] = useState({});
  let [tableData, setTableData] = useState([]);
  const issueGlanceRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  let [value, setValue] = useState("");
  let [loading, setLoading] = useState(false);
  let [hasChanged, setChanges] = useState(false);
  let [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  let [coverHandlerPopover, setCoverHandlerPopover] = useState(false);
  let [tocHandlerPopover, setTocHandlerPopover] = useState(false);
  let [webHandlerPopover, setWebHandlerPopover] = useState(false);
  let [finalizingHandlerPopover, setFinalizingHandlerPopover] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);

  let firstTimeRef = useRef(false);

  let formRef = useRef(false);

  useEffect(() => {
    const formElement = formRef.current;

    const handleScroll = () => {
      if (coverHandlerPopover) {
        setCoverHandlerPopover(false);
      }
      if (tocHandlerPopover) {
        setTocHandlerPopover(false);
      }
      if (webHandlerPopover) {
        setWebHandlerPopover(false);
      }
      if (finalizingHandlerPopover) {
        setFinalizingHandlerPopover(false);
      }
    };

    if (formElement) {
      formElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (formElement) {
        formElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [
    coverHandlerPopover,
    tocHandlerPopover,
    webHandlerPopover,
    finalizingHandlerPopover,
  ]);

  let Header = filteredArticleHeaders;
  let DateKeys = [
    "issueS300Date",
    "lastMsForSce",
    "issueHoldout",
    "issueFinalizing",
    "coverSubInvites",
    "coverSubDue",
    "coverDueToSupplier",
    "coverSentToSupplier",
    "coverLicenseInPts",
    "coverProofApproved",
    "tocOrderFromEditors",
    "tocToSupplier",
    "issueDetailsApproved",
    "allPapersFinalized",
    "issueDeliveredToEw",
    "starFormDue",
    "starFormSubmitted",
  ];

  let cleanedDate = (date) => {
    if (date) {
      const dateOnly = date.split("T")[0];
      return dateOnly;
    } else {
      return date;
    }
  };

  let UpdatedData = () => {
    let result = {};

    Object.keys(formdata).forEach((key) => {
      if (DateKeys.includes(key)) {
        result[key] = cleanedDate(formdata[key]);
      } else {
        result[key] = formdata[key];
      }
    });
    return result;
  };

  let FetchArticles = async () => {
    if (!firstTimeRef.current) {
      setLoading(true);
    }
    try {
      let response = await fetchArticleByIssue({
        id: formdata.issueId,
        key: sortConfig.key,
        direction: sortConfig.direction,
      });
      if (response.success && response?.data && response?.data?.length >= 1) {
        let articles = response?.data;
        setTableData(articles);
      }
    } catch (err) {
      setTableData([]);
    } finally {
      setLoading(false);
      firstTimeRef.current = true;
    }
  };

  useEffect(() => {
    let data = UpdatedData();
    setFormData(data);
    setInitialFormData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    FetchArticles();
  }, [sortConfig]);

  // Check for overflow after content loads
  useEffect(() => {
    const checkOverflow = () => {
      const contentDiv = document.querySelector(".content-container");
      if (contentDiv) {
        setHasOverflow(contentDiv.scrollHeight > contentDiv.clientHeight);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [tableData, formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  let HandleSubmit = async (e) => {
    try {
      e.preventDefault();
      setFormSubmitting(true);

      let {
        ArticleDetails,
        changes,
        updatedAt,
        createdAt,
        volIss,
        type,
        journal,
        team,
        ...rest
      } = formData;

      const sanitizedRest = Object.fromEntries(
        Object.entries(rest).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim() : value,
        ])
      );

      await onSave(sanitizedRest);
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setFormSubmitting(false);
    }
  };

  const isDeactivated = (fieldName) => {
    const field = fieldConfig.find((f) => f.key === fieldName);
    return !field || !field.manualOverwrite;
  };

  const handleDownloadExcel = () => {
    if (!tableData || tableData.length === 0) return;

    const columnMap = [
      { key: "tocOrderPosition", label: "TOC order position" },
      { key: "docHead", label: "Dochead" },
      { key: "correspondingAuthor", label: "Corr. author" },
      { key: "pts", label: "PTS#" },
      { key: "em", label: "EM#" },
      { key: "doi", label: "DOI" },
      { key: "url", label: "URL" },
      { key: "onDate", label: "ON date" },
      { key: "ptsMilestone", label: "PTS milestone" },
      { key: "oaStatus", label: "OA status" },
      { key: "freeFeaturedOnline", label: "Free featured online" },
      { key: "pressRelease", label: "Press release?" },
    ];

    const headers = columnMap.map((c) => c.label);

    const dataRows = tableData.map((row) =>
      columnMap.map(({ key }) => {
        const value = row[key];

        if (value === true) return "Yes";
        if (value === false) return "No";
        return value ?? "";
      })
    );

    const ws = XLSX.utils.aoa_to_sheet([headers, ...dataRows]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Articles");

    const journal =
      tableData.find((r) => r.Journal)?.Journal ?? "UnknownJournal";
    let volIss = tableData.find((r) => r.volIss)?.volIss ?? "UnknownVolIss";

    volIss = volIss.replace("/", "⁄");

    XLSX.writeFile(wb, `${journal}_${volIss}_report.xlsx`);
  };

  function isoToDateInputFormat(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  /**
   * Retrieves previous value for a field from change history
   * @param {string} fieldName - Name of the field
   * @returns {string|null} Previous value or null if none exists
   */
  const getPreviousValue = (fieldName) => {
    if (!formdata?.changes || !Array.isArray(formdata.changes)) return null;
    const changeEntry = formdata.changes.find(
      (change) =>
        change.key === fieldName &&
        change.previousValue !== null &&
        change.previousValue !== 0
    );
    return changeEntry ? isoToDateInputFormat(changeEntry.previousValue) : null;
  };

  // Check if any change object has key and non-null previousValue
  const hasChanges =
    formdata?.changes &&
    Array.isArray(formdata.changes) &&
    formdata.changes.some(
      (change) =>
        change.key &&
        change.previousValue !== null &&
        change.previousValue !== 0
    );

  const checkChanges = () => {
    for (const key in initialFormData) {
      const prev = initialFormData[key] === null ? "" : initialFormData[key];
      const current = formData[key] === null ? "" : formData[key];

      if (prev !== current) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    let value = checkChanges();
    setChanges(value);
  }, [formData]);

  // Helper function to check if a section should be hidden
  const isSectionHidden = (fields) => {
    const result = fields.every((field) => isDeactivated(field));
    return result;
  };

  console.log("formData", formData);

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Sticky Header */}
      <div className="sticky top-0 px-4 z-[70] pb-3 bg-white">
        <div className="space-x-2  flex flex-row items-center">
          <button onClick={Onclose}>
            <p className="text-[#5D6871] hover:underline text-[13px] mb-1">
              {text}
            </p>
          </button>
          <p className="text-[#5D6871] text-[13px] mb-1">
            <MdOutlineKeyboardArrowRight />
          </p>
          <p className="text-[#5D6871] text-[13px] mb-1">
            {formData?.ArticleDetails?.[0]?.volIss || formData?.volIss}
          </p>
        </div>
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              aria-label="Back"
              className="text-[#20282E] text-[23px]"
              onClick={Onclose}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
            <h1 className="text-[#20282E] text-[23px] h-[32px] font-semibold">
              {formData?.ArticleDetails?.[0]?.journalInfo?.journalName ||
                formData?.journalInfo?.journalName ||
                formData?.journalName ||
                "Journal"}{" "}
              {formData?.ArticleDetails?.[0]?.volIss || formData?.volIss}
            </h1>
          </div>
          <div
            className="text-[13px] font-semibold px-2 rounded-md h-[32px] hover:bg-[#B8C7FE] text-[#1C40C9] flex items-center space-x-1 cursor-pointer select-none"
            onClick={() => {
              issueGlanceRef.current?.scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            <img src={Book} className="h-[16px] w-[16px]" alt="" />
            <span className="text-[13px] h-[16px]">
              Go to issue at a glance
            </span>
          </div>
        </div>
        {/* {!hasChanges && (
          <div
            className="flex items-center bg-[#FFF6F0] h-[40px] border border-[#B95000] text-[#B95000] text-[16px] font-medium px-4 py-2 rounded mt-2 mb-2"
            role="alert"
          >
            <BiSolidError className="min-w-[16px]" />
            <span className="ml-2 whitespace-nowrap overflow-hidden text-ellipsis">
              Some fields show mismatched content. Please review each to confirm
              accuracy.
            </span>
          </div>
        )} */}
      </div>

      {/* Scrollable Content */}
      <div ref={formRef} className={`flex-1 overflow-y-auto  px-4 py-1.5`}>
        {formSubmitting && (
          <div className="backdrop-blur-sm z-20 fixed inset-0 ">
            <Spinner />
          </div>
        )}
        <h2 className="text-[20px] text-[#35424D] h-[24px] font-semibold mt-2 mb-4">
          Issue Details
        </h2>
        <form className="space-y-6">
          {/* Overview Section */}
          <div>
            <h3 className="text-[18px] h-[24px] text-[#5D6871] font-semibold mb-4">
              Overview
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
              <TextInput
                label="Journal"
                name="journal"
                value={
                  formData?.ArticleDetails?.[0]?.journalInfo?.journalName ||
                  formData?.journalInfo?.journalName ||
                  formData?.journalName
                }
                onChange={handleChange}
                disabled={true}
                // previousValue={getPreviousValue("journal")}
              />

              <DateInput
                label="Issue S300 date"
                name="issueS300Date"
                value={formData.issueS300Date}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("issueS300Date")}
              />

              <TextInput
                label="PII"
                name="piii"
                value={formData.piii}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("pii")}
              />
              <DateInput
                label="Last MS for SCE"
                name="lastMsForSce"
                value={formData.lastMsForSce}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("lastMsForSce")}
              />
              <DateInput
                label="Issue holdout"
                name="issueHoldout"
                value={formData.issueHoldout}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("issueHoldout")}
              />

              <DateInput
                label="Issue finalizing"
                name="issueFinalizing"
                value={formData.issueFinalizing}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("issueFinalizing")}
              />
              <DateInput
                label="Issue delivered to EW"
                name="issueDeliveredToEw"
                value={formData.issueDeliveredToEw}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("issueDeliveredToEw")}
              />
            </div>
          </div>
          {/* Cover Art Section */}
          <div>
            <h3 className="text-[18px] h-[24px] text-[#5D6871] font-semibold mb-4">
              Cover Art
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
              <NewSelectInput
                label="Cover handler"
                name="coverHandler"
                onChange={handleChange}
                value={formData.coverHandler}
                placeholder="Select Cover handler"
                options={optionsMap}
                popover={coverHandlerPopover}
                setPopover={setCoverHandlerPopover}
              />

              <div>
                <DateInput
                  label="Send cover invites by"
                  name="coverSubInvites"
                  value={formData.coverSubInvites}
                  onChange={handleChange}
                  disabled={true}
                  //previousValue={getPreviousValue("coverSubInvites")}
                />
              </div>

              <RadioInput
                name="coverInviteSent"
                value={formData.coverInviteSent}
                onChange={handleChange}
                label="Cover invites sent"
                //previousValue={getPreviousValue("coverInviteSent")}
              />

              <div>
                <DateInput
                  label=" Cover subs due"
                  name="coverSubDue"
                  value={formData.coverSubDue}
                  onChange={handleChange}
                  disabled={true}
                  //previousValue={getPreviousValue("coverSubDue")}
                />
              </div>

              <DateInput
                label="Cover due to TNQ"
                name="coverDueToSupplier"
                value={formData.coverDueToSupplier}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("coverDueToSupplier")}
              />

              <DateInput
                label="Cover sent to TNQ"
                name="coverSentToSupplier"
                value={formData.coverSentToSupplier}
                onChange={handleChange}
                //previousValue={getPreviousValue("coverSentToSupplier")}
              />

              <DateInput
                label="Cover license in PTS"
                name="coverLicenseInPts"
                value={formData.coverLicenseInPts}
                onChange={handleChange}
                //previousValue={getPreviousValue("coverLicenseInPts")}
              />

              <DateInput
                label="Cover proof approved"
                name="coverProofApproved"
                value={formData.coverProofApproved}
                onChange={handleChange}
                //previousValue={getPreviousValue("coverProofApproved")}
              />
            </div>
          </div>

          {/* TOC Section */}
          <div>
            <h3 className="text-[18px] h-[24px] text-[#5D6871] font-semibold mb-4">
              TOC
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
              {/* <SelectInput
                label="TOC handler"
                name="tocHandler"
                value={formData.tocHandler}
                onChange={handleChange}
                options={userOption}
                placeholder="select any option"
                //previousValue={getPreviousValue("tocHandler")}
              /> */}
              <NewSelectInput
                label="TOC handler"
                name="tocHandler"
                value={formData.tocHandler}
                placeholder="Select TOC handler"
                onChange={handleChange}
                options={optionsMap}
                popover={tocHandlerPopover}
                setPopover={setTocHandlerPopover}
              />

              <DateInput
                label="TOC order from editors"
                name="tocOrderFromEditors"
                value={formData.tocOrderFromEditors}
                onChange={handleChange}
                //previousValue={getPreviousValue("tocOrderFromEditors")}
              />

              <DateInput
                label="TOC to supplier"
                name="tocToSupplier"
                value={formData.tocToSupplier}
                onChange={handleChange}
                //previousValue={getPreviousValue("tocToSupplier")}
              />
            </div>
          </div>

          {/* Finalizing Section */}
          <div>
            <h3 className="text-[18px] h-[24px] text-[#5D6871] font-semibold mb-4">
              Finalizing
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
              {/* <SelectInput
                label="Finalizing handler"
                name="finalizingHandler"
                value={formData.finalizingHandler}
                onChange={handleChange}
                options={userOption}
                placeholder="select any option"
                //previousValue={getPreviousValue("finalizingHandler")}
              /> */}
              <NewSelectInput
                label="Finalizing handler"
                name="finalizingHandler"
                onChange={handleChange}
                value={formData.finalizingHandler}
                placeholder="Select Finalizing handler"
                options={optionsMap}
                popover={finalizingHandlerPopover}
                setPopover={setFinalizingHandlerPopover}
              />

              <DateInput
                label="Issue details approved"
                name="issueDetailsApproved"
                value={formData.issueDetailsApproved}
                onChange={handleChange}
                //previousValue={getPreviousValue("issueDetailsApproved")}
              />

              <DateInput
                label="All papers finalized"
                name="allPapersFinalized"
                value={formData.allPapersFinalized}
                onChange={handleChange}
                //previousValue={getPreviousValue("allPapersFinalized")}
              />
            </div>
          </div>

          {/* Web Section */}
          <div>
            <h3 className="text-[18px] h-[24px] text-[#5D6871] font-semibold mb-4">
              Web
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4">
              {/* <SelectInput
                label="Web handler"
                name="webHandler"
                value={formData.webHandler}
                onChange={handleChange}
                options={userOption}
                placeholder="select any option"
                //previousValue={getPreviousValue("webHandler")}
              /> */}
              <NewSelectInput
                label="Web handler"
                name="webHandler"
                value={formData.webHandler}
                onChange={handleChange}
                placeholder="Select Web handler"
                options={optionsMap}
                popover={webHandlerPopover}
                setPopover={setWebHandlerPopover}
              />

              <DateInput
                label="st@r form due"
                name="starFormDue"
                value={formData.starFormDue}
                onChange={handleChange}
                disabled={true}
                //previousValue={getPreviousValue("strFormDue")}
              />

              <DateInput
                label="st@r form submitted"
                name="starFormSubmitted"
                value={formData.starFormSubmitted}
                onChange={handleChange}
                //previousValue={getPreviousValue("strFormSubmitted")}
              />
            </div>
          </div>

          {/* Table Section */}
          <div ref={issueGlanceRef}>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-[#35424D] text-[24px] h-[20px] font-semibold">
                Issue at a glance
              </h3>
              <button
                type="button"
                className="border-[#1C40C9] hover:bg-[#B8C7FE] h-[32px] border-2 w-[188px] rounded-md items-center justify-center"
                onClick={handleDownloadExcel}
              >
                <span className="text-[#1C40C9] h-[16px] text-[13px] font-semibold">
                  Download article report (.XLS)
                </span>
              </button>
            </div>
            {loading ? (
              <Spinner />
            ) : tableData?.length > 0 ? (

              <div
                className=" issue-glance-table mt-2 border border-gray-300 overflow-x-auto
                            [&_th]:!py-1.5 [&_td]:!py-1.5
                            [&_th]:!px-2 [&_td]:!px-2
                            [&_th]:!h-auto [&_td]:!h-auto
                            [&_th]:!leading-tight [&_td]:!leading-tight
                            "
              >
                <CustomTable
                  headers={Header}
                  data={tableData}
                  setActiveRowId={setValue}
                  sortConfig={sortConfig}
                  setSortConfig={setSortConfig}
                />
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8">
                <img src={bookPng} alt="No tasks" className="w-[90px] h-[90px]" />
                <p className="text-[#35424D] font-semibold text-lg mb-4">
                  No Articles Data
                </p>
                <p className="text-[#5D6871] text-sm mb-4">
                  There are no Article Mapped with this Issue
                </p>
              </div>
            )}
          </div>
        </form>
      </div>

      {/* Sticky Footer */}
      <div className="sticky bottom-0 z-[50] bg-white border-t border-gray-200 px-4">
        <div className="py-2 w-full flex justify-end space-x-4">
          <button
            type="button"
            className="text-sm font-normal text-blue-700"
            onClick={Onclose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`bg-blue-700 text-white text-sm font-normal px-4 py-2 rounded ${
              !hasChanged
                ? " cursor-not-allowed bg-gray-300 text-gray-500 text-sm font-normal"
                : ""
            }`}
            onClick={HandleSubmit}
            disabled={!hasChanged}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default IssueDetails;
